import API from "@lib/api";
import { BaseApi } from "@api";
import { Messages } from "@interfaces";

import { IMunicipios } from "../interfaces";

export class MunicipalityApi extends BaseApi {
  protected static api = API({ namespace: "Municipios" });
  protected static filterApi = API({ namespace: "Filtro" });
  protected static messages: Messages<typeof MunicipalityApi> = {};

  public static async getAll(): Promise<IMunicipios[]> {
    const result = await this.api.get("GetAll");
    return result.data;
  }
}
